import { DialogService, GridAction } from '@eforall/dashboard';
import { AccTeamDialog, AccVentureDialog, PersonDialog } from '../../../../../../../ui/widget';
import { DeliveryAreaService } from '../../../../../delivery-area.service';
import { DeliveryAccEntrepreneur } from '../all-entrepreneurs-view.part';

export function getActions(dialogService: DialogService, areaService: DeliveryAreaService): GridAction<DeliveryAccEntrepreneur>[] {

	const actions: GridAction<DeliveryAccEntrepreneur>[] = [
		{
			iconClass: 'fa-regular fa-pencil',
			label: 'View Person Details',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				await dialogService.showCustom(PersonDialog, { data: { personId: rows[0]!.personId, toEdit: false } }, 800, 800);
			}
		},
		{
			iconClass: 'fa-regular fa-pencil',
			label: 'View Venture Details',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				await dialogService.showCustom(AccVentureDialog, { data: { accVentureId: rows[0]!.accVentureId } }, 900, 700);
				await areaService.reloadData();
			}
		},
		{
			iconClass: 'fa-regular fa-file-lines',
			label: 'View Team Details',
			isEnabled: rows => !!rows.length && !!rows[0] && !!rows[0]!.accTeamId,
			execute: async rows => {
				await dialogService.showCustom(AccTeamDialog, { data: { accTeamId: rows[0]!.accTeamId } }, 900, 900);
				await areaService.reloadData();
			}
		},
	];

	return actions;
}